import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'antd'
import { connect } from 'react-redux'
import "./feeback.css"
import { saveFeedback, getFeedbackQuestions, setStep, pauseGame, fetchGameState } from '../../reduxStore/actions/action'
import SettingsModal from '../components/settingsModal'
import { CaretLeftOutlined } from '@ant-design/icons'
import ApiClass from '../../services/Api'

const Downloaded = ({ isDownloaded, setIsDownloaded, setStep, utilAssets }) => {
    return (
        <Modal
            open={isDownloaded}
            onCancel={() => setIsDownloaded(false)}
            footer={null}
            closeIcon={false}
            className='token-model'
            maskClosable={false}
        >
            <div className="r-c-c" style={{ width: "100%", height: "100dvh" }}>
                <div className='r-c-c' style={{ width: "100%", height: "100%" }}>
                    <img src={utilAssets?.modalBg} className='full-img' alt="Modal Background" />
                </div>
                <div className='r-c-c-c' style={{ position: "absolute" }}>
                    <div style={{ fontSize: 30, fontWeight: "bolder", width: "70%", textAlign: "center" }}>
                        Feedback successfully downloaded
                    </div>
                    <div className='r-c-c play-btn m-t-10' style={{ width: '50%' }}>
                        <Button onClick={() => { setStep(5); setIsDownloaded(false) }}>NEXT</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

function FeedBack({ learningCardData, correctValueBuddies, valueBuddiesImg, getFeedbackQuestions, setStep, saveFeedback, pauseGame, userDetails, gameAssets, utilAssets, setIsSkipped, fetchGameState }) {
    console.log("learningData", learningCardData)

    const [isDownloaded, setIsDownloaded] = useState(false);
    const [isOpenModalSetting, setIsOpenModalSetting] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [formData, setFormData] = useState([]);
    const fbIcons = [
        utilAssets?.fbIcon1,
        utilAssets?.fbIcon2,
        utilAssets?.fbIcon3,
        utilAssets?.fbIcon4,
        utilAssets?.fbIcon5,
        utilAssets?.fbIcon6
    ]
    const handleSetting = () => {
        setIsOpenModalSetting(true);
        setOpenSettings(true);
        pauseGame(true)
    }

    useEffect(() => {
        fetchGameState(() => { }, () => { })
    }, [])
    useEffect(() => {
        getFeedbackQuestions((feedbackData) => {
            setFormData(feedbackData?.map(ele => {
                let obj = {};
                obj["questionId"] = ele.id;
                obj["feedback"] = correctValueBuddies?.map(v => {
                    return {
                        "valueBuddy": valueBuddiesImg[v - 1].name,
                        response: ''
                    }
                })
                return obj;
            }))
        }, () => {

        })
    }, [])

    const baseUrl = ApiClass._base_url
    // Handle form submission (optional)
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Data:', formData);

        saveFeedback({ response: formData }, (response) => {
            console.log("fedd", response, baseUrl + response?.downloadLink)
            if (response?.downloadLink) {
                const link = document.createElement('a');
                link.href = baseUrl + response?.downloadLink;
                link.download = 'feedback_responses.xlsx'; // You can set a default name for the downloaded file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsDownloaded(true)
            } else {
                // Handle the case where there's no download link
                console.error('Download link not found in response');
            }

            setIsSkipped(false);


        }, (err) => {
            console.error('Error saving feedback:', err);
        });
    };

    const BehaviorFeed = ({ learningData, index1, fbIc }) => {
        console.log("learningDataa", learningData)

        return (
            <div className="behavior-feed">


                <div className="r-c-fs beh-feed-sub">
                    <div style={{ border: "", width: "100%", height: "50%" }}>
                        <img className='full-img' src={utilAssets?.fbQuestionBg} style={{ objectFit: "fill" }} alt="Behavior Background" />
                    </div>
                    <div className='beh-cards'>
                        <div className="r-c-fs cards-header" style={{}}>
                            <div className='card-ic'><img className='full-img' src={fbIc} /> </div>
                            <div className="feed-question-text" >{learningData?.question}</div>
                        </div>
                        <div className=' cards-input-box'>
                            {correctValueBuddies?.map((item, index) => (
                                <div className='' style={{ width: "100%", display: "flex", padding: "5px 0px" }}>
                                    <span class='input-1 r-c-fs' data-fulltext="{valueBuddiesImg[item - 1].name}">
                                        {valueBuddiesImg[item - 1].name}
                                    </span>
                                    <input
                                        type="text"
                                        required
                                        minLength={5}
                                        className='r-c-fs input-2'
                                        onChange={(e) => {

                                            formData[index1]["questionId"] = learningData?.['id']
                                            formData[index1]["question"] = learningData?.['question']
                                            formData[index1]["feedback"][index]["response"] = e.target.value
                                            setFormData(formData)
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                    </div>
                </div>

            </div>
        )
    }

    return (
        <div className="super-parent">
            <div className='r-c-c header-text' >What did you learn on this journey? Share with us on this card</div>
            <form onSubmit={handleSubmit}>
                <div className='r-c-c behaviour-parent' >

                    <div className='r-c-c-c beh-bg'>
                        <img className='full-img' src={utilAssets?.feedbackBg} alt="Learning Background" />
                        <div className='learning-card-company-logo' style={{}}>
                            <img className='full-img' style={{ objectFit: "contain" }} src={gameAssets?.companyLogo} />
                        </div>
                        <div className="flex-container-feed scroll-bar-universal">
                            {learningCardData?.map((item, index) => (
                                <div key={index} className="flex-item-feed">
                                    <BehaviorFeed learningData={item} fbIc={fbIcons[index]} index1={index} />
                                </div>
                            ))}
                        </div>

                        <div className='r-c-c powered-by-text'>Powered by The Gamification Company. </div>
                    </div>
                </div>
                <div className="r-c-c m-t-15 done-btn-learning " style={{}}>
                    {/* <Button style={{ width: "15%", minHeight: "5vh", marginRight: 10, borderRadius: 30 }} onClick={() => { setStep(5); setIsSkipped(true) }}>SKIP</Button>  */}
                    <Button style={{ width: "max-content", minHeight: "5vh", borderRadius: 30 }} htmlType='submit'>DOWNLOAD</Button></div>
            </form>
            {isOpenModalSetting && <SettingsModal
                isOpenModal={isOpenModalSetting}
                setIsOpenModal={setIsOpenModalSetting}
                setIsOpenModalSetting={setIsOpenModalSetting}
                setOpenSettings={setOpenSettings}
                openSettings={openSettings}
            />}
            {isDownloaded && <Downloaded isDownloaded={isDownloaded} setIsDownloaded={setIsDownloaded} setStep={setStep} utilAssets={utilAssets} />}
        </div>
    )
}

const mapStateToProps = state => {

    const { learningCardData, correctValueBuddies, valueBuddiesImg, userDetails, gameAssets, utilAssets } = state?.SeTu;
    return { learningCardData, correctValueBuddies, valueBuddiesImg, userDetails, gameAssets, utilAssets }
}


const mapDispatchToProps = dispatch => ({
    getFeedbackQuestions: (successCallBack, callBack) => dispatch(getFeedbackQuestions(successCallBack, callBack)),
    saveFeedback: (params, successCallBack, callBack) => dispatch(saveFeedback(params, successCallBack, callBack)),
    setStep: (val) => dispatch(setStep(val)),
    pauseGame: (val) => dispatch(pauseGame(val)),
    fetchGameState: (successCallBack, callBack) => dispatch(fetchGameState(successCallBack, callBack)),

})

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack)
